import React, { forwardRef } from 'react';

import InputTemplate from '../TemplateNumberFormatInput';

const FloatInput = forwardRef(({ escala = 2, ...props }, ref) => (
  <InputTemplate {...props} escala={escala} prefixo="" ref={ref} />
));

export default FloatInput;
